import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { toBoolean } from '@shared/helpers/utils.helper';

@Component({
    selector: 'boolean-checkbox-input',
    templateUrl: './boolean-checkbox-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BooleanCheckboxInputComponent),
            multi: true,
        },
    ],
})
export class BooleanCheckboxInputComponent implements ControlValueAccessor {
    @Input() inputId: string;

    checked = false;
    isDisabled = false;

    private _onChange: (value: '0' | '1') => void = () => {};
    private _onTouched: () => void = () => {};

    constructor(private readonly cdr: ChangeDetectorRef) {}

    writeValue(value: unknown): void {
        this.checked = toBoolean(value);
        this.cdr.markForCheck();
    }

    registerOnChange(fn: (value: '0' | '1') => void): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this._onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
        this.cdr.markForCheck();
    }

    onChanged(event: Event): void {
        this.checked = (event.target as HTMLInputElement).checked;
        this._onChange(this.checked ? '1' : '0');
    }

    onTouched(): void {
        this._onTouched();
    }
}
